<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>内容管理</a-breadcrumb-item>
    <a-breadcrumb-item>片库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 剧名： -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input v-model:value="name" class="tool-item" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <!-- 上架状态： -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">上架状态：</a-col>
          <a-col :span="18">
            <a-select v-model:value="OnShelfStatus" class="tool-item" placeholder="请选择">
              <a-select-option :value="-1">全部</a-select-option>
              <a-select-option v-for="item in OnShelfStatusOptions" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 排序： -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">排序：</a-col>
          <a-col :span="18">
            <a-select v-model:value="sortKey" class="tool-item" placeholder="请选择">
              <a-select-option v-for="item in sortOptions" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="handleReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 多选组件 -->
  <TableCheckbox
    sourceKey="id"
    :dataSource="dataSource"
    :selectedRowKeys="selectedRowKeys"
    :selectedRows="selectedRows"
    :pagination="pagination"
    :isLoading="isLoading"
  >
    <!-- 按钮文案 -->
    <template #checkbox>
      <a-button style="margin: 0 10px 0 10px;" @click="batchShelves('down')">下架</a-button>
      <a-button @click="batchShelves('up')">上架</a-button>
    </template>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 剧名 -->
        <template v-if="column.key === 'name'">
          <!-- <img class="cover-img" :src="$pub.CDN_URL(record && record.s_cover[0].url)">
          <span class="cover-title">{{ record.remark_name }}</span>
          <a-tooltip>
            <template #title>{{ record.name }}</template>
            <info-circle-outlined style="margin-left: 6px; cursor: pointer;" />
          </a-tooltip> -->
          <a-tooltip>
            <template #title>{{ record.lang_drama_name }}</template>
            <span style="cursor: pointer;">{{ record.name }}</span>
          </a-tooltip>
          <!-- {{ record.name }} -->
        </template>
        <!-- 总集数 -->
        <template v-if="column.key === 'total_ep'">
          {{ record.total_ep }}集
        </template>
        <!-- 状态 -->
        <template v-if="column.key === 'status'">
          {{ record.status === 1 ? '在架' : '下架' }}
        </template>
        <!-- 视频语种 -->
        <template v-if="column.key === 'lang_id'">
          {{ (languages.find(item => item.id === record.lang_id) || {}).name || '-' }}
        </template>
        <!-- 操作 -->
        <template v-if="column.key === 'operation'">
          <a class="operation-item" @click="touchInfo(record)">编辑</a>
          <a class="operation-item" @click="touchSubtitles(record)">字幕</a>
        </template>
      </template>
    </a-table>
  </TableCheckbox>
  <!-- 基本信息 -->
  <BaseInfo ref="RefBaseInfo" @success="getList"></BaseInfo>
  <!-- 剧集 -->
  <SubtitlesDrawer ref="RefSubtitlesDrawer"></SubtitlesDrawer>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { OnShelfStatusOptions } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import BaseInfo from './components/BaseInfo'
import SubtitlesDrawer from './components/SubtitlesDrawer'
import TableCheckbox from '@/components/TableCheckbox'
import { langSearchList } from '@/api/admin'
import { getDramaList, setDramaShelf } from '@/api/appfront'

// 基本信息组件实例
let RefBaseInfo = ref(null)
// 剧集组件实例
let RefSubtitlesDrawer = ref(null)
// 剧名
let name = ref(undefined)
// 上架状态
let OnShelfStatus = ref(undefined)
// 排序
let sortKey = ref('weight')
// 语种列表
let languages = ref([])
// 排序项
let sortOptions = ref([
  {
    value: 'weight',
    text: '权重降序'
  },
  {
    value: 'id',
    text: '入库时间降序'
  },
])
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '剧ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '剧名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '评级',
    dataIndex: 'grade',
    key: 'grade'
  },
  {
    title: '权重',
    dataIndex: 'weight',
    key: 'weight'
  },
  {
    title: '总集数',
    dataIndex: 'total_ep',
    key: 'total_ep'
  },
  {
    title: '视频语种',
    dataIndex: 'lang_id',
    key: 'lang_id'
  },
  {
    title: '上架状态',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  // 获取语种列表
  getLanguages()
  // 获取列表
  getList()
})

// 查询
function handleSearch () {
  pagination.current = 1
  // 获取列表
  getList()
}

// 获取语种列表
function getLanguages () {
  const params = {
    page: 1,
    page_size: 10000
  }
  langSearchList(params).then(res => {
    const { code, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 多选处理
let selectedRowKeys = ref([])
let selectedRows = ref([])
function onSelectChange (rowKeys, rows) {
  selectedRowKeys.value = rowKeys
  selectedRows.value = rows
}

// 重置
function handleReset () {
  // 筛选项重置
  name.value = undefined
  OnShelfStatus.value = undefined
  sortKey.value = 'weight'
  // 分页重置
  pagination.current = 1
  getList()
}

// 获取数据
function getList () {
  isLoading.value = true
  const params = {
    in_storage: 1,
    name: name.value,
    status: OnShelfStatus.value,
    key: sortKey.value,
    sort: 'desc',
    page: pagination.current,
    page_size: pagination.pageSize
  }
  getDramaList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
      // 清空多选状态
      selectedRowKeys.value = []
      selectedRows.value = []
    } else {
      message.error(res.message || msg)
    }
  })
}

// 批量上下架
function batchShelves (type) {
  isLoading.value = true
  setDramaShelf({
    type,
    ids: selectedRowKeys.value
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      message.success('操作成功')
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 基本信息
function touchInfo (record) {
  RefBaseInfo.value.showDrawer(record, true)
}

// 剧集
function touchSubtitles (record) {
  RefSubtitlesDrawer.value.showDrawer(record)
}
</script>

<style scoped>
.cover-img {
  display: inline-block;
  width: 40px;
  height: 40px;
}
.cover-title {
  margin-left: 10px;
}
</style>